import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentView from "../../myComp/ContentView";

class ProductList extends PlusComponent {
  constructor(props) {
    super(props, "contentProduct");         
  }

  render(){     
    return (
        <div>
          <ContentView {...this.props} title="Prodotti" controller="contentProduct"></ContentView>
        </div>
      )
    }
}

export default ProductList;